import React from 'react';
import { useIntl } from 'react-intl';
import { ButtonWithLoader } from '../../../components/other/Buttons';

interface IProps {
  changeAuthTab: any;
  email: string;
}

export const EmailSent: React.FC<IProps> = ({ changeAuthTab, email }) => {
  const intl = useIntl();
  return (
    <div className='kt-login__body'>
      <div className='kt-login__form'>
        <div className='kt-login__title'>
          <h3>{intl.formatMessage({ id: 'AUTH.EMAIL.TITLE' })}</h3>
        </div>
        <div className='kt-login__subtitle'>
          <h5>{intl.formatMessage({ id: 'AUTH.EMAIL.DESCRIPTION' }, { name: email })}</h5>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
          <div className='kt-login__actions' style={{ marginRight: 30 }}>
            <ButtonWithLoader 
              type='button' 
              onPress={() => changeAuthTab('CheckInSystem')}
              variant='contained'
              color='secondary'
            >
              {intl.formatMessage({ id: 'AUTH.GENERAL.BACK_BUTTON' })}
            </ButtonWithLoader>
          </div>
        </div>
      </div>
    </div>
  );
};
